import Vue from 'vue';

Vue.mixin({
  methods: {
    $openNotification(message): void {
      this.$global_eventEmitter.$emit('setNotificationData', message);
    },
  },
});
